import { render } from "./IncomingPage.vue?vue&type=template&id=5716c0f0"
import script from "./IncomingPage.vue?vue&type=script&lang=js"
export * from "./IncomingPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__